<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Administration - Connexion</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="username"
                label="Nom d'utilisateur"
                name="username"
                prepend-icon="mdi-account"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Mot de passe"
                name="password"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                required
                @keyup.enter="login"
              ></v-text-field>
            </v-form>
            <v-alert v-if="error" type="error" dense class="mt-3">
              {{ error }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading" @click="login">Se connecter</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      password: '',
      showPassword: false,
      loading: false,
      error: null,
      username: '',
    };
  },
  methods: {
    async login() {
      if (!this.password) return;
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.post(`${process.env.VUE_APP_URL}admin/api/login`, {username: this.username, password: this.password });
        if (response.data.success) {
          localStorage.setItem('adminToken', response.data.token);
          this.$router.push({ name: 'AdminForms' });
        }
      } catch (err) {
        this.error = (err.response && err.response.data && err.response.data.message) || 'Une erreur est survenue';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
